import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

export const ThankYouPopup = () => {
  const location = useLocation();
  const [show, setShow] = useState(false);

  useEffect(() => {
    const state = location.state;
    if (state?.showThankYou) {
      setShow(true);
      // Clear state so popup doesn't show again on refresh
      window.history.replaceState({}, document.title, location.pathname + location.search);
    }
  }, [location.state, location.pathname, location.search]);

  if (!show) return null;

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm transition-opacity duration-300">
      <div className="bg-white rounded-2xl shadow-2xl max-w-md w-full p-8 text-center transform transition-transform duration-300 scale-100">
        <div className="w-16 h-16 mx-auto mb-4 rounded-full bg-[#84CC16]/20 flex items-center justify-center">
          <svg
            className="w-8 h-8 text-[#84CC16]"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M5 13l4 4L19 7"
            />
          </svg>
        </div>
        <h3 className="text-2xl font-bold text-black mb-2">
          Thank you for informing us!
        </h3>
        <p className="text-gray-600 mb-6">
          We will reach out soon.
        </p>
        <button
          onClick={() => setShow(false)}
          className="w-full py-3 px-6 rounded-lg font-semibold bg-[#84CC16] text-white hover:bg-[#6db315] transition-colors"
        >
          Got it
        </button>
      </div>
    </div>
  );
};
